// extracted by mini-css-extract-plugin
export default {"root":"DropNotify__root--2TiAI","content":"DropNotify__content--3gqof"};